import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Text } from 'rebass'
import Modal from '../../components/Modal'
import { AutoColumn } from '../../components/Column'
import { RowBetween } from '../../components/Row'
import { ButtonSecondary } from '../../components/Button'
import { CloseIcon } from '../../theme/components'
import { ORDERBOOK_API_BASE } from '../../constants/orderbook'

interface SyncOrderByTxModalProps {
  isOpen: boolean
  onDismiss: () => void
  onSuccess: () => void
}

export default function SyncOrderByTxModal({ isOpen, onDismiss, onSuccess }: SyncOrderByTxModalProps) {
  const { t } = useTranslation()
  const [txHash, setTxHash] = useState('')
  const [pending, setPending] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const handleSubmit = async () => {
    const hash = txHash.trim()
    if (!hash) {
      setError(t('orderSyncByTxErrorEmpty'))
      return
    }
    setError(null)
    setPending(true)
    try {
      const res = await fetch(`${ORDERBOOK_API_BASE}/sync-order-by-tx`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ txHash: hash })
      })
      const data = await res.json()
      if (data.code === 0) {
        onSuccess()
        onDismiss()
        setTxHash('')
      } else {
        setError(data.msg || t('orderSyncByTxError'))
      }
    } catch (e) {
      console.error('Sync order by tx failed:', e)
      setError(t('orderSyncByTxError'))
    } finally {
      setPending(false)
    }
  }

  const handleClose = () => {
    setTxHash('')
    setError(null)
    onDismiss()
  }

  return (
    <Modal isOpen={isOpen} onDismiss={handleClose} maxHeight={90}>
      <div style={{ width: '100%', padding: 24 }}>
        <RowBetween>
          <Text fontWeight={500} fontSize={20}>
            {t('orderSyncByTxTitle')}
          </Text>
          <CloseIcon onClick={handleClose} />
        </RowBetween>
        <AutoColumn gap="16px" style={{ marginTop: 20 }}>
          <input
            type="text"
            value={txHash}
            onChange={e => setTxHash(e.target.value)}
            placeholder={t('orderSyncByTxPlaceholder')}
            style={{
              width: '100%',
              padding: '12px 14px',
              fontSize: 14,
              border: `1px solid var(--bg3)`,
              borderRadius: 8,
              backgroundColor: 'var(--bg2)',
              color: 'var(--text1)'
            }}
          />
          {error && (
            <Text fontSize={14} color="var(--red1)">
              {error}
            </Text>
          )}
          <ButtonSecondary onClick={handleSubmit} disabled={pending}>
            <Text fontWeight={500} fontSize={16}>
              {pending ? t('orderSyncByTxSubmitting') : t('orderSyncByTxSubmit')}
            </Text>
          </ButtonSecondary>
        </AutoColumn>
      </div>
    </Modal>
  )
}
